import api from "../services/api";
import globalToast from "../components/common/globalToast";
import { formatDateBR } from "../utils/functions";
import { metalNames, stepNames } from "../utils/data_variables";
import { getProductionSteps, mapProductionStepNames } from "./http_production_steps_requests";
import axios from "axios";

const service_path = '/production.php';

export function getProduction(id, filters = {}) {
    const cleanFilters = Object.entries(filters).reduce((acc, [key, value]) => {
        if (value !== '' && value !== null && value !== undefined) {
            acc[key] = value;
        }
        return acc;
    }, {});

    if (id) {
        cleanFilters.step = id;
    }

    const params = new URLSearchParams(cleanFilters).toString();
    const url = params ? `${service_path}?${params}` : service_path;

    return api.get(url);
};

export function updateProduction(idOrder, navigateBack) {

    api.patch(service_path, { idOrder: idOrder })
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success();
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error();
        });
};

export function updateProductionClosing(data, navigateBack) {

    api.put(service_path, data)
        .then(response => {
            const { data } = response;

            if (data.success) {
                globalToast.success();
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error();
        });
};

export function printScreeningTicket(data) {

    const sendTicket = (names) => {
        const getProductionStepsNames = (stepsJson) => {
            if (!stepsJson || !Array.isArray(stepsJson)) return [];
            return stepsJson.map(step => names[step] || `Passo ${step}`);
        };

        const getMetalName = (metalId) => {
            return metalNames[metalId] || `Material ${metalId}`;
        };

        const payload = {
            id: data.id,
            self_reference: data.self_reference,
            category: data.is_service ? "SERVIÇO" : "PRODUTO",
            selected_metal: {
                id: data.selected_metal,
                name: getMetalName(data.selected_metal)
            },
            prod_steps: getProductionStepsNames(data.prod_steps_json),
            ordered_at: formatDateBR(data.ordered_at),
            production_date: formatDateBR(data.production_date),
            delivery_date: formatDateBR(data.delivery_date),
        };

        axios.post('http://localhost:5000/print-production', payload)
            .then(response => {
                const { data: body } = response;
                globalToast.success(body.message);
            })
            .catch(error => {
                console.log(error);
            });
    };

    getProductionSteps()
        .then((response) => sendTicket(mapProductionStepNames(response?.data?.data || [])))
        .catch(() => sendTicket(stepNames));
}

export function updateProductionScreening(content, navigateBack) {

    api.put(service_path, content)
        .then(response => {

            printScreeningTicket(content);

            const { data } = response;

            if (data.success) {
                globalToast.success();
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error();
        });
};
